import { wrapper } from '../store';
import { getCommonServerSideProps } from '../api/getMainServerSideProps';
import { getMatchesBySport, getParseUrl, PageTypeByUrl } from '../api'
import { HomePage, LeaguePage, MatchPage, PageFifaRanking } from '../feature-pages'
import { getCompetition } from '@/api/competitionsApi'
import { setSlugType } from '@/features/app'
import { QUERY_KEY_LANG_PREV, QUERY_KEY_SLUG_TYPE } from '@/const'

const getComponentByMethod = (type: PageTypeByUrl, props: any) => {
    switch (type) {
    case 'match':
        return <MatchPage {...props} />
    case 'competition':
        return <LeaguePage {...props} />
    case 'ranking':
        return <PageFifaRanking {...props} />
    default:
        return <HomePage {...props} />
    }
}

const getServerSidePropsByMethod = async (type: PageTypeByUrl, store: any, context: any) => {
    switch (type) {
    case 'match':
        return await MatchPage.getSSRProps(store, context);
    case 'competition':
        return await LeaguePage.getSSRProps(store, context);
    case 'ranking':
        return await PageFifaRanking.getSSRProps(store);
    default:
        return await HomePage.getSSRProps(store, context);
    }
}

export default function DynamicRouteHandler(_props: any) {
    return getComponentByMethod(_props.method, _props);
}

export const getServerSideProps = wrapper.getServerSideProps(
    (store) => async (context) => {
        if (context.resolvedUrl.includes('_next')) return null

        const commonProps = await getCommonServerSideProps(store, context);

        const {
            query,
            locale,
            resolvedUrl,
        } = context
        let method: PageTypeByUrl = '_main';
        let meta: any = null
        let hreflang: any = null

        try {
            const url = `/${locale}${resolvedUrl}`;
            const data = await store.dispatch(
                getParseUrl.initiate({ url, locale })
            );

            // Try to replace invalid page url, basically if language was changed
            if (data.status === 'rejected' && query[QUERY_KEY_SLUG_TYPE]) {
                let urlValid = ''

                // Get previous language from context query
                const langPrev = query[QUERY_KEY_LANG_PREV] as string ?? 'en'
                const urlWithoutParams = resolvedUrl.split('?')[0]

                if (query[QUERY_KEY_SLUG_TYPE] === 'competition') {
                    // Have to parse valid competition url to get its params
                    const competitionUrlData = await store.dispatch(
                        getParseUrl.initiate({
                            url: `/${langPrev}${urlWithoutParams}`,
                            locale: langPrev,
                        })
                    );

                    // Then fetch competition data with new local and get valid url for it
                    const [id, season] = competitionUrlData.data.data.parameters
                    const competitionData = await store.dispatch(
                        getCompetition.initiate({
                            id,
                            season,
                            locale,
                        })
                    );

                    urlValid = competitionData.data.data.competition[0]?.url ?? ''
                }

                if (query[QUERY_KEY_SLUG_TYPE] === '_main') {
                    // Get valid sport name for new locale
                    const matchesData = await store.dispatch(
                        getMatchesBySport.initiate({
                            sport: 1,
                            locale: locale,
                        })
                    );

                    urlValid = '/' + (matchesData.data?.data?.sport?.url_title ?? '')
                    // Pass filter params
                    const [_, _sport, ...urlRest] = urlWithoutParams.split('/')
                    if (urlRest) urlValid += '/' + urlRest.join('/')
                }

                return {
                    redirect: {
                        destination: `/${locale}${urlValid}`,
                        permanent: true,
                    },
                }
            }

            // If parsed url doesn't match resolved, redirect to parsed
            if (data.data.data.url && data.data.data.url !== resolvedUrl) {
                return {
                    redirect: {
                        destination: `/${locale}${data.data.data.url}`,
                        permanent: true,
                    },
                }
            }

            method = data.data.data.api_method;
            store.dispatch(setSlugType(method))

            // modify context by id for SSR
            context.query.id = data.data.data.parameters;
            // @ts-ignore
            commonProps.props.id = data.data.data.parameters;
            meta = data.data.data.meta
            hreflang = data.data.data.hreflang
        } catch (e) {
            return { // <-----------------does the trick here!!
                notFound: true,
            }
        }

        const addProps = await getServerSidePropsByMethod(method, store, context);

        return {
            props: {
                ...commonProps.props,
                method,
                meta,
                hreflang,
                ...addProps,
            },
        }
    }
)